import { Injectable, NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { ApiService } from './services/api.service';

import { OfferComponent } from './components/offer/offer.component';
import { RegisterComponent } from './components/register/register.component';
import { EndedComponent } from './components/ended/ended.component';
import { ErrorComponent } from './components/error/error.component';
import { IncorrectComponent } from './components/incorrect/incorrect.component';
import { IneligibleComponent } from './components/ineligible/ineligible.component';
import { EnrolledComponent } from './components/enrolled/enrolled.component';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private apiService : ApiService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
      return this.apiService.isAuthenticated();
  }
}

const routes: Routes = [
  { path: '', redirectTo: '/register', pathMatch: 'full' },
  { path: 'register', component: RegisterComponent, canActivate: [AuthGuard] },
  { path: 'offer', component: OfferComponent },
  { path: 'incorrect', component: IncorrectComponent },
  { path: 'ineligible', component: IneligibleComponent },
  { path: 'enrolled', component: EnrolledComponent },
  { path: 'ended', component: EndedComponent },
  { path: 'error', component: ErrorComponent },
  {
    path: '**', // 404
    redirectTo: '/register'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

